define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {
		process: function() {
			// summary: collapse lowest level of table
			var	hl = this.widget.getLevelToCollapse();
			if (hl != null) {
				this.widget.collapse(hl);
			}
			
			this.postProcess(true);
		}
	});
});